import React from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';
import { compareWithOnlineAddress } from 'utils/Seminar';
import Link from 'components/Link';

const SeminarLocation = (props) => {
  const {
    venue,
    street,
    city,
    state,
    postalCode,
    venueClass,
    addressClass,
    linkClass,
  } = props;

  const hasAddress = Boolean(city);
  const isOnlineAddress = hasAddress && compareWithOnlineAddress(city);
  let address1 = null;
  let address2 = null;
  if (hasAddress) {
    address1 = isOnlineAddress ? city : street;
    address2 = isOnlineAddress ? null : `${city}, ${state} ${postalCode}`;
  }

  if (isOnlineAddress) {
    return <span className={classes.address}>Online</span>;
  }

  return (
    <div>
      {venue && <div className={venueClass}>{venue}</div>}
      {address1 && <div className={addressClass}>{address1}</div>}
      {address2 && <div className={addressClass}>{address2}</div>}
      {(address1 || address2) &&
        <div>
          <Link
            href={`https://maps.google.com/?q=${address1} ${address2}`}
            target='_blank'
            className={linkClass}
          >
            View Map
          </Link>
        </div>}
    </div>
  );
};

SeminarLocation.propTypes = {
  venue: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  venueClass: PropTypes.string,
  addressClass: PropTypes.string,
  linkClass: PropTypes.string,
};

export default SeminarLocation;
